module.exports = __webpack_public_path__ + "img/logo_dy.44cb1d5b.png";